/**
 * PDP Redesign - Gallery Enhancements
 * Adds corner accents, image counter, and active thumbnail badges
 */
(function() {
  'use strict';

  var section = document.querySelector('.pdp-redesign');
  if (!section) return;

  var mediaWrapper = section.querySelector('.product__media-list-wrapper');

  // --- Image Counter ---
  var flickityCarousel = section.querySelector('.product__media-list');
  if (flickityCarousel && mediaWrapper) {
    var counter = document.createElement('div');
    counter.className = 'pdp-image-counter';
    counter.innerHTML = '<span>1 / 1</span>';
    mediaWrapper.appendChild(counter);

    function updateCounter() {
      var items = flickityCarousel.querySelectorAll('.product__media-item:not(.is-filtered)');
      var selectedItem = flickityCarousel.querySelector('.product__media-item.is-selected:not(.is-filtered)');
      var total = items.length;
      var current = 1;

      if (selectedItem) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] === selectedItem) {
            current = i + 1;
            break;
          }
        }
      }

      counter.querySelector('span').textContent = current + ' / ' + total;
    }

    // Initial update
    updateCounter();

    // Watch for slide changes via MutationObserver
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' || mutations[i].attributeName === 'aria-current') {
          updateCounter();
          break;
        }
      }
    });

    var mediaItems = flickityCarousel.querySelectorAll('.product__media-item');
    mediaItems.forEach(function(item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    // Also observe flickity's settle event if available
    if (typeof flickityCarousel.addEventListener === 'function') {
      flickityCarousel.addEventListener('settle.flickity', function() {
        updateCounter();
      });
    }
  }

  // --- Custom Mobile Nav Arrows ---
  if (mediaWrapper) {
    var mobileNav = document.createElement('div');
    mobileNav.className = 'pdp-mobile-nav';
    mobileNav.innerHTML = '<button type="button" class="pdp-mobile-nav__prev" aria-label="Previous" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"></path></svg></button><button type="button" class="pdp-mobile-nav__next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"></path></svg></button>';
    mediaWrapper.appendChild(mobileNav);

    var mobilePrev = mobileNav.querySelector('.pdp-mobile-nav__prev');
    var mobileNext = mobileNav.querySelector('.pdp-mobile-nav__next');

    function updateMobileArrowVisibility() {
      var allItems = section.querySelectorAll('.product__media-item:not(.is-filtered)');
      var selectedItem = section.querySelector('.product__media-item.is-selected:not(.is-filtered)');
      if (!selectedItem || allItems.length <= 1) {
        mobilePrev.style.display = 'none';
        mobileNext.style.display = 'none';
        return;
      }
      var currentIdx = -1;
      for (var i = 0; i < allItems.length; i++) {
        if (allItems[i] === selectedItem) { currentIdx = i; break; }
      }
      mobilePrev.style.display = currentIdx > 0 ? 'flex' : 'none';
      mobileNext.style.display = currentIdx < allItems.length - 1 ? 'flex' : 'none';
    }

    function triggerFlickityNav(direction) {
      var flickityBtn = section.querySelector('.product__media-prev-next[data-action="' + direction + '"], .flickity-button.' + (direction === 'prev' ? 'previous' : 'next'));
      if (flickityBtn) {
        flickityBtn.click();
      } else {
        var navBtns = section.querySelectorAll('.product__media-prev-next');
        navBtns.forEach(function(btn) {
          if (btn.getAttribute('data-action') === direction) btn.click();
        });
      }
      setTimeout(updateMobileArrowVisibility, 100);
    }

    mobilePrev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); triggerFlickityNav('prev'); });
    mobileNext.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); triggerFlickityNav('next'); });

    // Initial visibility
    updateMobileArrowVisibility();

    // Update on slide change
    if (flickityCarousel) {
      var mobileArrowObserver = new MutationObserver(function() { updateMobileArrowVisibility(); });
      var mobileMediaItems = flickityCarousel.querySelectorAll('.product__media-item');
      mobileMediaItems.forEach(function(item) {
        mobileArrowObserver.observe(item, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  // --- Custom Lightbox ---
  if (mediaWrapper) {
    // Create expand button
    var lbBtn = document.createElement('button');
    lbBtn.className = 'pdp-lightbox-btn is-hidden';
    lbBtn.setAttribute('type', 'button');
    lbBtn.setAttribute('aria-label', 'Expand image');
    lbBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1h7v7"></path><path d="M8 19H1v-7"></path><line x1="19" y1="1" x2="11.5" y2="8.5"></line><line x1="1" y1="19" x2="8.5" y2="11.5"></line></svg>';
    mediaWrapper.appendChild(lbBtn);

    // Create lightbox overlay with prev/next navigation
    var lbOverlay = document.createElement('div');
    lbOverlay.className = 'pdp-lightbox-overlay';
    lbOverlay.innerHTML = '<button class="pdp-lightbox-close" type="button" aria-label="Close">&times;</button>' +
      '<button class="pdp-lightbox-prev" type="button" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>' +
      '<div class="pdp-lightbox-content"></div>' +
      '<button class="pdp-lightbox-next" type="button" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>' +
      '<div class="pdp-lightbox-counter"><span></span></div>';
    document.body.appendChild(lbOverlay);

    var lbContent = lbOverlay.querySelector('.pdp-lightbox-content');
    var lbClose = lbOverlay.querySelector('.pdp-lightbox-close');
    var lbPrev = lbOverlay.querySelector('.pdp-lightbox-prev');
    var lbNext = lbOverlay.querySelector('.pdp-lightbox-next');
    var lbCounter = lbOverlay.querySelector('.pdp-lightbox-counter span');
    var lbCurrentIndex = 0;

    function getLightboxMedia() {
      var items = section.querySelectorAll('.product__media-item:not(.is-filtered)');
      var media = [];
      items.forEach(function(item) {
        var type = item.getAttribute('data-media-type');
        if (type === 'video') {
          var video = item.querySelector('video');
          if (video) {
            media.push({ type: 'video', src: video.querySelector('source') ? video.querySelector('source').src : video.src });
          } else {
            // Video may be in a template (autoplay off) — get poster image instead
            var poster = item.querySelector('.video-wrapper__poster-image');
            var tpl = item.querySelector('template');
            if (tpl) {
              var tmpDiv = document.createElement('div');
              tmpDiv.innerHTML = tpl.innerHTML;
              var tplVideo = tmpDiv.querySelector('video');
              if (tplVideo) {
                media.push({ type: 'video', src: tplVideo.querySelector('source') ? tplVideo.querySelector('source').src : tplVideo.src });
              } else {
                // Fallback to image
                var img = item.querySelector('img');
                if (img) media.push({ type: 'image', src: img.currentSrc || img.src });
              }
            } else if (poster) {
              media.push({ type: 'image', src: poster.currentSrc || poster.src });
            }
          }
        } else if (type === 'external_video') {
          var tpl = item.querySelector('template');
          if (tpl) {
            var tmpDiv = document.createElement('div');
            tmpDiv.innerHTML = tpl.innerHTML;
            var iframe = tmpDiv.querySelector('iframe');
            if (iframe) {
              media.push({ type: 'iframe', src: iframe.src });
            }
          } else {
            var iframe = item.querySelector('iframe');
            if (iframe) media.push({ type: 'iframe', src: iframe.src });
          }
        } else {
          var img = item.querySelector('img');
          if (img) media.push({ type: 'image', src: img.currentSrc || img.src });
        }
      });
      return media;
    }

    function showLightboxMedia(index) {
      var media = getLightboxMedia();
      if (media.length === 0) return;
      lbCurrentIndex = ((index % media.length) + media.length) % media.length;
      var item = media[lbCurrentIndex];

      if (item.type === 'video') {
        lbContent.innerHTML = '<video class="pdp-lightbox-video" src="' + item.src + '" controls autoplay playsinline></video>';
      } else if (item.type === 'iframe') {
        lbContent.innerHTML = '<iframe class="pdp-lightbox-iframe" src="' + item.src + '" allowfullscreen allow="autoplay"></iframe>';
      } else {
        lbContent.innerHTML = '<img src="' + item.src + '" alt="Product">';
      }

      if (lbCounter) {
        lbCounter.textContent = (lbCurrentIndex + 1) + ' / ' + media.length;
      }
    }

    function openLightbox() {
      var items = section.querySelectorAll('.product__media-item:not(.is-filtered)');
      var selectedItem = section.querySelector('.product__media-item.is-selected:not(.is-filtered)');
      lbCurrentIndex = 0;
      if (selectedItem) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] === selectedItem) { lbCurrentIndex = i; break; }
        }
      }
      showLightboxMedia(lbCurrentIndex);
      lbOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lbOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      lbContent.innerHTML = ''; // Stop any playing video
    }

    lbBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openLightbox();
    });

    lbPrev.addEventListener('click', function(e) {
      e.stopPropagation();
      showLightboxMedia(lbCurrentIndex - 1);
    });

    lbNext.addEventListener('click', function(e) {
      e.stopPropagation();
      showLightboxMedia(lbCurrentIndex + 1);
    });

    lbClose.addEventListener('click', closeLightbox);
    lbOverlay.addEventListener('click', function(e) {
      if (e.target === lbOverlay) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (!lbOverlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxMedia(lbCurrentIndex - 1);
      if (e.key === 'ArrowRight') showLightboxMedia(lbCurrentIndex + 1);
    });

  }

  // --- Hide expand button on video slides ---
  function updateExpandButtonVisibility() {
    var selectedItem = section.querySelector('.product__media-item.is-selected:not(.is-filtered)');
    var expandBtn = section.querySelector('.pdp-lightbox-btn');
    if (!expandBtn || !selectedItem) return;
    var mediaType = selectedItem.getAttribute('data-media-type');
    if (mediaType === 'video' || mediaType === 'external_video') {
      expandBtn.style.display = 'none';
    } else {
      expandBtn.style.display = '';
    }
  }

  // Run on slide change
  if (flickityCarousel) {
    var expandObserver = new MutationObserver(updateExpandButtonVisibility);
    flickityCarousel.querySelectorAll('.product__media-item').forEach(function(item) {
      expandObserver.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
    updateExpandButtonVisibility();
  }

  // --- Mobile: Auto-hide counter and expand button after 2s ---
  function setupMobileAutoHide() {
    if (window.innerWidth >= 1000) return;
    var counterEl = section.querySelector('.pdp-image-counter');
    var expandEl = section.querySelector('.pdp-lightbox-btn');
    var hideTimer = null;

    function showOverlays() {
      if (counterEl) counterEl.classList.remove('is-hidden');
      if (expandEl) expandEl.classList.remove('is-hidden');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function() {
        if (counterEl) counterEl.classList.add('is-hidden');
        if (expandEl) expandEl.classList.add('is-hidden');
      }, 2000);
    }

    // Show on touch/interaction, then auto-hide
    if (mediaWrapper) {
      mediaWrapper.addEventListener('touchstart', showOverlays, { passive: true });
      mediaWrapper.addEventListener('click', showOverlays);
    }

    // Keep overlays hidden on initial load; show them only after user interaction.
    if (counterEl) counterEl.classList.add('is-hidden');
    if (expandEl) expandEl.classList.add('is-hidden');
  }

  setupMobileAutoHide();

  // --- LED Type Value Splitter ---
  // Splits "RGBW (solid colors + white)" into "RGBW" (red) + "Solid colors + white" (gray)
  function splitLedTypeValues() {
    var optionInfos = section.querySelectorAll('.product-form__option-info');
    optionInfos.forEach(function(info) {
      var nameEl = info.querySelector('.product-form__option-name');
      if (!nameEl) return;
      var nameText = nameEl.textContent.trim().toLowerCase();
      if (nameText.indexOf('led type') === -1) return;

      var valueEl = info.querySelector('.product-form__option-value');
      if (!valueEl || valueEl.dataset.pdpSplit) return;
      valueEl.dataset.pdpSplit = 'true';

      var isFormatting = false;

      function formatValue() {
        if (isFormatting) return;
        isFormatting = true;

        // Get raw text — if already formatted, read from the name span
        var nameSpan = valueEl.querySelector('.pdp-led-value-name');
        var text = nameSpan ? nameSpan.textContent.trim() : valueEl.textContent.trim();

        // If text has no paren, check if Shopify just replaced it with raw text
        if (!nameSpan && text.indexOf('(') === -1) {
          isFormatting = false;
          return;
        }

        if (!nameSpan) {
          var lowerText = text.toLowerCase();
          var hasCompatibilityDetail =
            lowerText.indexOf('pin') !== -1 ||
            lowerText.indexOf('connector') !== -1 ||
            lowerText.indexOf('wire') !== -1 ||
            lowerText.indexOf('wiring') !== -1 ||
            lowerText.indexOf('adapter') !== -1 ||
            lowerText.indexOf('splitter') !== -1 ||
            lowerText.indexOf('m8') !== -1 ||
            lowerText.indexOf('jst') !== -1;

          if (hasCompatibilityDetail) {
            isFormatting = false;
            return;
          }

          var parenIndex = text.indexOf('(');
          if (parenIndex > 0) {
            var mainPart = text.substring(0, parenIndex).trim();
            var descPart = text.substring(parenIndex).replace(/^\(/, '').replace(/\)$/, '').trim();
            valueEl.innerHTML = '<span class="pdp-led-value-name">' + mainPart + '</span> <span class="pdp-led-value-desc">' + descPart + '</span>';
          }
        }

        isFormatting = false;
      }

      formatValue();

      // Re-format when variant changes — use requestAnimationFrame for speed
      var valObserver = new MutationObserver(function() {
        requestAnimationFrame(formatValue);
      });
      valObserver.observe(valueEl, { childList: true, characterData: true, subtree: true });
    });
  }

  splitLedTypeValues();

  /* JCI EDIT START — PDP Redesign native variant-combination availability.
   * Shopify's theme availability code maps controls by data-selector-type. The
   * custom LED cards are radios, so they need a scoped mapper that uses the
   * native variant options instead of a visual-control or option-name assumption.
   */
  function setupPdpVariantAvailability() {
    var variantPicker = section.querySelector('product-variants');
    var variantDataElement = variantPicker && variantPicker.querySelector('[data-pdp-variant-availability]');
    if (!variantPicker || !variantDataElement) return;

    var variants;
    try {
      variants = JSON.parse(variantDataElement.textContent);
    } catch (error) {
      console.warn('PDP variant availability data could not be parsed.', error);
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    var hideSoldOutVariants = variantPicker.hasAttribute('hide-sold-out-variants');
    var productForm = document.getElementById(variantPicker.getAttribute('form-id'));
    var updateTimer = null;

    function getOptionPosition(control) {
      var match = control && control.name && control.name.match(/^option(\d+)$/);
      return match ? parseInt(match[1], 10) - 1 : -1;
    }

    function getSelectedOptionValues() {
      var selectedValues = [];
      variantPicker.querySelectorAll('input[name^="option"]:checked, select[name^="option"]').forEach(function(control) {
        var position = getOptionPosition(control);
        if (position >= 0) selectedValues[position] = control.value;
      });
      return selectedValues;
    }

    function findDropdownItem(selector, value) {
      return Array.from(selector.querySelectorAll('.combo-box__option-item')).find(function(item) {
        return item.getAttribute('value') === value;
      }) || null;
    }

    function findVisualItem(selector, control, value) {
      var customCard = control.closest('.pdp-led-type-option');
      if (customCard) return customCard;

      if (selector.getAttribute('data-selector-type') === 'dropdown') {
        return findDropdownItem(selector, value);
      }

      return control.closest(
        '.pdp-led-type-option, .color-swatch, .variant-swatch, .block-swatch'
      );
    }

    function setValueAvailability(selector, control, value, exists, available) {
      var visualItem = findVisualItem(selector, control, value);
      var shouldHide = !exists || (hideSoldOutVariants && !available);
      var isSoldOut = exists && !available && !hideSoldOutVariants;

      if (visualItem) {
        visualItem.toggleAttribute('hidden', shouldHide);
        visualItem.classList.toggle('is-disabled', isSoldOut);
      }

      if (control.tagName === 'OPTION' || control.tagName === 'INPUT') {
        control.disabled = shouldHide;
      }
    }

    function variantMatchesPreviousSelections(variant, optionPosition, selectedValues) {
      for (var position = 0; position < optionPosition; position += 1) {
        if (
          typeof selectedValues[position] !== 'undefined' &&
          variant.options[position] !== selectedValues[position]
        ) {
          return false;
        }
      }
      return true;
    }

    function updateAvailability() {
      var selectedValues = getSelectedOptionValues();

      variantPicker.querySelectorAll('.product-form__option-selector[data-selector-type]').forEach(function(selector) {
        var select = selector.querySelector('select[name^="option"]');
        var controls = select
          ? Array.from(select.options)
          : Array.from(selector.querySelectorAll('input[name^="option"]'));
        if (controls.length === 0) return;

        var optionPosition = getOptionPosition(select || controls[0]);
        if (optionPosition < 0) return;

        controls.forEach(function(control) {
          var value = control.value;
          var matchingVariants = variants.filter(function(variant) {
            return (
              variant.options[optionPosition] === value &&
              variantMatchesPreviousSelections(variant, optionPosition, selectedValues)
            );
          });
          var exists = matchingVariants.length > 0;
          var available = matchingVariants.some(function(variant) {
            return variant.available;
          });

          setValueAvailability(selector, control, value, exists, available);
        });
      });
    }

    function scheduleAvailabilityUpdate() {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(updateAvailability, 0);
    }

    variantPicker.addEventListener('change', scheduleAvailabilityUpdate);
    document.addEventListener('variant:changed', function(event) {
      if (event.target === productForm) {
        scheduleAvailabilityUpdate();
      }
    });

    updateAvailability();
  }

  setupPdpVariantAvailability();
  /* JCI EDIT END — PDP Redesign native variant-combination availability. */

  // --- Responsive Compact Variant Pills ---
  // JCI edits — eligibility and variant synchronization remain shared across viewports.
  // Adds a pill UI for short dropdown options while keeping the
  // existing select/combo-box as the source of truth for Shopify variant logic.
  function setupMobileVariantPills() {
    if (!document.body.classList.contains('template-product-pdp-redesign')) return;

    var maxPillValueLength = 32;
    var maxPillHeadingLength = 32;
    var maxPillValues = 50;
    var dropdownOnlyOptionNames = [];

    function cleanText(text) {
      return (text || '').replace(/\s+/g, ' ').trim();
    }

    function normalizeOptionName(selector) {
      var nameEl = selector && selector.querySelector('.product-form__option-name');
      if (!nameEl) return '';

      if (!nameEl.dataset.pdpOptionBaseName) {
        nameEl.dataset.pdpOptionBaseName = cleanText(nameEl.textContent).replace(/[:\s]+$/g, '');
      }

      nameEl.textContent = nameEl.dataset.pdpOptionBaseName + ':';
      return nameEl.dataset.pdpOptionBaseName;
    }

    function isManualDropdownOnly(selector, optionName) {
      if (selector.matches('[data-mobile-selector="dropdown"], [data-mobile-pills="false"], .pdp-mobile-dropdown-only')) return true;

      var normalizedName = optionName.toLowerCase();
      return dropdownOnlyOptionNames.some(function(name) {
        return normalizedName === String(name).toLowerCase();
      });
    }

    function isEligible(selector) {
      if (!selector || selector.getAttribute('data-selector-type') !== 'dropdown') return false;

      var optionName = normalizeOptionName(selector);
      if (!optionName || isManualDropdownOnly(selector, optionName)) return false;

      var select = selector.querySelector('select[name^="option"]');
      if (!select) return false;

      var values = Array.from(select.options).map(function(option) {
        return cleanText(option.textContent || option.value);
      });

      if (values.length < 2 || values.length > maxPillValues) return false;

      return values.every(function(value) {
        return value.length <= maxPillValueLength;
      });
    }

    function updatePillScrollState(pillList) {
      if (!pillList) return;
      pillList.classList.toggle('is-scrollable', pillList.scrollWidth > pillList.clientWidth + 1);
    }

    // JCI edits — qualified pills must also fit their real desktop viewport.
    function evaluateDesktopPillFit(selector) {
      var pillList = selector && selector.querySelector('.pdp-mobile-option-pills');
      if (!pillList) return;

      if (!window.matchMedia('(min-width: 1000px)').matches) {
        selector.classList.remove('product-form__option-selector--desktop-dropdown');
        return;
      }

      var wasFallback = selector.classList.contains('product-form__option-selector--desktop-dropdown');
      if (wasFallback) selector.classList.add('product-form__option-selector--measuring-pills');

      var hasOverflow = pillList.scrollWidth > pillList.clientWidth + 2;

      selector.classList.remove('product-form__option-selector--measuring-pills');
      selector.classList.toggle('product-form__option-selector--desktop-dropdown', hasOverflow);
    }

    function scheduleDesktopPillFit(selector) {
      if (!selector || selector._pdpPillFitFrame) return;
      selector._pdpPillFitFrame = window.requestAnimationFrame(function() {
        selector._pdpPillFitFrame = null;
        evaluateDesktopPillFit(selector);
      });
    }

    function updateMobilePillHeadingLength(selector) {
      var optionName = normalizeOptionName(selector);
      if (!optionName) return;

      selector.classList.toggle('product-form__option-selector--mobile-heading-long', optionName.length > maxPillHeadingLength);
    }

    function ensureMobilePillSelectedValue(selector) {
      var select = selector.querySelector('select[name^="option"]');
      var nameEl = selector.querySelector('.product-form__option-name');
      var mobileSelectedValueEl = selector.querySelector('.pdp-mobile-option-selected-value');
      if (!select || !nameEl) return null;

      if (!mobileSelectedValueEl) {
        mobileSelectedValueEl = document.createElement('span');
        mobileSelectedValueEl.className = 'pdp-mobile-option-selected-value';
        nameEl.insertAdjacentElement('afterend', mobileSelectedValueEl);
      }

      mobileSelectedValueEl.textContent = select.value;
      return mobileSelectedValueEl;
    }

    function updateMobilePillSelectedValue(selector) {
      var select = selector.querySelector('select[name^="option"]');
      var selectedValueEl = selector.querySelector('.select__selected-value');
      var mobileSelectedValueEl = selector.querySelector('.pdp-mobile-option-selected-value');
      if (!select) return;

      if (selectedValueEl) {
        selectedValueEl.textContent = select.value;
      }

      if (mobileSelectedValueEl) {
        mobileSelectedValueEl.textContent = select.value;
      }

      var visiblePillCount = selector.querySelectorAll('.pdp-mobile-option-pill:not([hidden]):not(.is-disabled)').length;
      selector.classList.toggle('product-form__option-selector--mobile-show-value', visiblePillCount >= 4);
    }

    function updatePills(selector) {
      var select = selector.querySelector('select[name^="option"]');
      var pillList = selector.querySelector('.pdp-mobile-option-pills');
      if (!select || !pillList) return;

      pillList.querySelectorAll('.pdp-mobile-option-pill').forEach(function(pill) {
        var pillIndex = Array.prototype.indexOf.call(pillList.children, pill);
        var comboOption = selector.querySelector('.combo-box__option-item:nth-child(' + (pillIndex + 1) + ')');
        var isSelected = pill.getAttribute('data-value') === select.value;
        var isHidden = comboOption && comboOption.hasAttribute('hidden');
        var isDisabled = comboOption && comboOption.classList.contains('is-disabled');

        pill.classList.toggle('is-selected', isSelected);
        pill.classList.toggle('is-disabled', !!isDisabled);
        var shouldHide = !!isHidden || !!isDisabled;
        pill.hidden = shouldHide;
        pill.disabled = shouldHide;
        pill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      requestAnimationFrame(function() {
        updatePillScrollState(pillList);
        evaluateDesktopPillFit(selector);
      });

      updateMobilePillSelectedValue(selector);
    }

    section.querySelectorAll('.product-form__option-selector[data-selector-type="dropdown"]').forEach(function(selector) {
      if (selector.dataset.pdpMobilePillsReady) return;
      if (!isEligible(selector)) return;

      var selectWrapper = selector.querySelector('.select-wrapper');
      var select = selector.querySelector('select[name^="option"]');
      if (!selectWrapper || !select) return;

      selector.dataset.pdpMobilePillsReady = 'true';
      selector.classList.add('product-form__option-selector--mobile-pills');
      updateMobilePillHeadingLength(selector);
      ensureMobilePillSelectedValue(selector);

      var pillList = document.createElement('div');
      pillList.className = 'pdp-mobile-option-pills';
      pillList.style.setProperty('--pdp-mobile-pill-columns', String(select.options.length));

      Array.from(select.options).forEach(function(option) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'pdp-mobile-option-pill';
        pill.textContent = cleanText(option.textContent || option.value);
        pill.setAttribute('data-value', option.value);
        pill.setAttribute('aria-pressed', option.selected ? 'true' : 'false');

        pill.addEventListener('click', function() {
          if (select.value === option.value) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          updatePills(selector);
        });

        pillList.appendChild(pill);
      });

      selectWrapper.insertAdjacentElement('afterend', pillList);

      if (window.ResizeObserver) {
        var pillFitObserver = new ResizeObserver(function() {
          scheduleDesktopPillFit(selector);
        });
        pillFitObserver.observe(selector);
      }

      var comboOptionList = selector.querySelector('.combo-box__option-list');
      if (comboOptionList && window.MutationObserver) {
        var comboObserver = new MutationObserver(function() {
          updatePills(selector);
        });
        comboObserver.observe(comboOptionList, {
          attributes: true,
          subtree: true,
          attributeFilter: ['hidden', 'class']
        });
      }

      select.addEventListener('change', function() {
        requestAnimationFrame(function() {
          updatePills(selector);
        });
      });

      updatePills(selector);
      window.setTimeout(function() {
        updatePills(selector);
      }, 250);
    });

    document.addEventListener('variant:changed', function() {
      section.querySelectorAll('.product-form__option-selector--mobile-pills').forEach(updatePills);
    });

    // JCI edits — recheck after font metrics and breakpoint changes settle.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        section.querySelectorAll('.product-form__option-selector--mobile-pills').forEach(scheduleDesktopPillFit);
      });
    }

    var desktopPillMedia = window.matchMedia('(min-width: 1000px)');
    desktopPillMedia.addEventListener('change', function() {
      section.querySelectorAll('.product-form__option-selector--mobile-pills').forEach(scheduleDesktopPillFit);
    });
  }

  setupMobileVariantPills();

  // --- Shorten Shop Pay Installments Message ---
  // Shopify dynamically injects this text into a custom element, often using a Shadow DOM.
  function shortenShopPayMessage() {
    if (!document.body.classList.contains('template-product-pdp-redesign')) return;

    var termsWrapper = document.querySelector('.pdp-redesign shopify-payment-terms');
    if (!termsWrapper) return;

    function doShorten(root) {
      var contentEl = root.querySelector('#shopify-installments-content');
      if (!contentEl) return false;

      var didShorten = false;
      var walker = document.createTreeWalker(contentEl, NodeFilter.SHOW_TEXT);
      var textNodes = [];
      var node;

      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }

      textNodes.forEach(function(textNode) {
        var rawText = textNode.nodeValue;
        var newText = rawText
          .replace(/\d+\s+interest-free installments?,\s+or\s+from/i, 'From')
          .replace(/Pay in\s+\d+\s+interest-free installments? of\s*/i, 'From ')
          .replace(/\d+\s+interest-free installments?,\s+or/i, '');

        if (/^\s*From/i.test(newText) && !/\/mo\s+with/i.test(newText)) {
          newText = newText.replace(/(\$\s?[\d,.]+)(\s*)with/i, '$1/mo$2with');
        }

        if (newText !== rawText) {
          textNode.nodeValue = newText.replace(/\s{2,}/g, ' ');
          didShorten = true;
        }
      });

      if (didShorten) {
        termsWrapper.classList.add('is-ready');
      }

      return didShorten;
    }

    function showTerms() {
      termsWrapper.classList.add('is-ready');
    }

    function runShorten() {
      return doShorten(termsWrapper) || (termsWrapper.shadowRoot && doShorten(termsWrapper.shadowRoot));
    }

    var shadowObserver = null;

    function attachShadowObserver() {
      if (!termsWrapper.shadowRoot || shadowObserver) return;

      shadowObserver = new MutationObserver(function() {
        runShorten();
      });

      shadowObserver.observe(termsWrapper.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    function scheduleShorten() {
      [0, 80, 200, 450, 900, 1400, 2200].forEach(function(delay) {
        window.setTimeout(function() {
          attachShadowObserver();
          runShorten();
          showTerms();
        }, delay);
      });
    }


    var observer = new MutationObserver(function() {
      attachShadowObserver();
      runShorten();
    });

    // Start observing the wrapper for child changes and the shadow root once Shopify creates it.
    observer.observe(termsWrapper, { childList: true, subtree: true });
    attachShadowObserver();

    document.addEventListener('variant:changed', scheduleShorten);
    scheduleShorten();
  }

  shortenShopPayMessage();
})();

/**
 * <pdp-stock-shipping> — Stock & Shipping Status block
 *
 * Reads per-variant {available, preorder} state from the inline JSON, listens
 * for the theme's variant:changed event, and re-renders the status pill.
 *
 *   - Preorder branch fires when the variant is on preorder AND the product's
 *     custom.preorder_delivery_note metafield is filled. The merchant's
 *     "Preorder text" template is interpolated by replacing [date].
 *   - Otherwise falls back to the In Stock / Out of Stock text.
 *
 * Free Shipping pill and the appended custom-status note are static — they
 * don't change per variant.
 *
 * Defined outside the gallery IIFE so it registers even if .pdp-redesign is
 * absent on the page (defensive — Shopify reorders sections in the editor).
 */
(function () {
  function formatMobileWarrantyButtons() {
    if (!document.body.classList.contains('template-product-pdp-redesign')) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 999px)').matches) return;

    document.querySelectorAll('.pdp-redesign .warranty-plan-btn').forEach(function (button) {
      var label = button.querySelector('span:not(.price-value):not(.checkmark)');
      var price = button.querySelector('.price-value');

      if (label) {
        var labelText = label.textContent || '';
        var yearMatch = labelText.match(/\d+/);
        if (yearMatch) label.textContent = yearMatch[0] + 'Y:';
      }

      if (price) {
        price.textContent = (price.textContent || '').replace(/\.00\b/g, '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatMobileWarrantyButtons);
  } else {
    formatMobileWarrantyButtons();
  }
})();

(function () {
  if (customElements.get('pdp-stock-shipping')) return;

  customElements.define('pdp-stock-shipping', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-pdp-stock-data]');
      if (!dataEl) return;
      try {
        this.config = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      this.statusEl = this.querySelector('[data-pdp-stock-status]');
      this.preorderEl = this.querySelector('[data-pdp-stock-preorder-note]');
      this.preorderDividerEl = this.querySelector('[data-pdp-stock-preorder-divider]');
      this.restockEl = this.querySelector('[data-pdp-stock-restock-note]');
      this.restockDividerEl = this.querySelector('[data-pdp-stock-restock-divider]');
      if (!this.statusEl) return;

      this._handler = this.handleVariantChange.bind(this);
      document.addEventListener('variant:changed', this._handler);

      // JCI edits: measure actual wrapped rows, including font loads and mobile resizing.
      // Decorative separators do not take up space, so toggling them cannot change wrapping.
      this.statusItems = Array.from(this.children).filter(function (item) {
        return item.tagName === 'SPAN' && !item.classList.contains('pdp-stock-shipping__divider');
      });
      this._rowObserver = new ResizeObserver(() => this.updateRowDividers());
      this._rowObserver.observe(this);
      this.statusItems.forEach(item => this._rowObserver.observe(item));
      this.updateRowDividers();
    }

    disconnectedCallback() { 
      if (this._handler) document.removeEventListener('variant:changed', this._handler);
      // JCI edits: clean up when Shopify replaces the section in the Theme Editor.
      if (this._rowObserver) this._rowObserver.disconnect();
    }

    // JCI edits: only items sharing a rendered row need a separator between them.
    updateRowDividers() {
      var previousRect = null;
      this.statusItems.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var visible = !item.hidden && rect.width > 0 && rect.height > 0;
        var sameRow = visible && previousRect &&
          rect.top < previousRect.bottom - 1 && rect.bottom > previousRect.top + 1;
        item.classList.toggle('pdp-stock-shipping__same-row', Boolean(sameRow));
        if (visible) previousRect = rect;
      });
    }

    handleVariantChange(e) {
      var variant = e && e.detail && e.detail.variant;
      if (!variant) return;
      var state = this.config.variants[variant.id];
      if (!state) return;

      // Status pill — always In Stock or Out of Stock based on tracked inventory.
      var statusHTML, modifier;
      if (state.in_stock) {
        statusHTML = this.config.in_stock_text;
        modifier = 'in-stock';
      } else {
        statusHTML = this.config.out_of_stock_text;
        modifier = 'out-of-stock';
      }
      this.statusEl.innerHTML = statusHTML;
      this.statusEl.className = 'pdp-stock-shipping__status pdp-stock-shipping__status--' + modifier;

      // Restock ETA note — appended slot, only when the variant is out of stock
      // AND the product's custom.restock_eta metafield is filled.
      if (this.restockEl) {
        if (!state.in_stock && this.config.restock_eta) {
          this.restockEl.innerHTML = this.config.restock_eta_text.replace(/\[date\]/g, this.config.restock_eta);
          this.restockEl.hidden = false;
          if (this.restockDividerEl) this.restockDividerEl.hidden = false;
        } else {
          this.restockEl.hidden = true;
          if (this.restockDividerEl) this.restockDividerEl.hidden = true;
        }
      }

      // Preorder note — appended slot, only when this variant qualifies and the
      // preorder_delivery_note metafield is filled.
      if (this.preorderEl) {
        if (state.preorder && this.config.preorder_note) {
          this.preorderEl.innerHTML = this.config.preorder_text.replace(/\[date\]/g, this.config.preorder_note);
          this.preorderEl.hidden = false;
          if (this.preorderDividerEl) this.preorderDividerEl.hidden = false;
        } else {
          this.preorderEl.hidden = true;
          if (this.preorderDividerEl) this.preorderDividerEl.hidden = true;
        }
      }
      // JCI edits: refresh separators after variant-dependent text and visibility change.
      this.updateRowDividers();
    }
  });
})();
